module.exports = __webpack_public_path__ + "static/media/FAQs.b9a9b4e0.svg";